export default (item) => {
	const index = Array.from(item.parentNode.children).indexOf(item);
	return index;
};
